import { render } from "./language-setting-modal.vue?vue&type=template&id=dbc63d22"
import script from "./language-setting-modal.vue?vue&type=script&lang=js"
export * from "./language-setting-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__